import { render, staticRenderFns } from "./LibraryHeader.vue?vue&type=template&id=3e551b64&scoped=true&"
import script from "./LibraryHeader.vue?vue&type=script&lang=ts&"
export * from "./LibraryHeader.vue?vue&type=script&lang=ts&"
import style0 from "./LibraryHeader.vue?vue&type=style&index=0&id=3e551b64&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e551b64",
  null
  
)

export default component.exports